import { render, staticRenderFns } from "./Lesson5.vue?vue&type=template&id=07d2d804&scoped=true&"
import script from "./Lesson5.vue?vue&type=script&lang=js&"
export * from "./Lesson5.vue?vue&type=script&lang=js&"
import style0 from "./Lesson5.vue?vue&type=style&index=0&id=07d2d804&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d2d804",
  null
  
)

export default component.exports